// Mock data for Greva Electric website

export const companyInfo = {
  name: "Greva Electric",
  tagline: "Professional Electrical Services in Saskatoon",
  phone: "306-249-2011",
  email: "greva_electric@outlook.com",
  address: "Saskatoon, SK",
  businessHours: {
    weekdays: "Mon - Fri: 08:00 AM to 05:00 PM",
    weekend: "Sat-Sun: Emergency Service Available"
  }
};

export const services = [
  {
    id: 1,
    title: "Commercial Electrical",
    description: "Greva Electric's electricians in Saskatoon, SK, offer expert commercial electrical services for businesses, offices, and industrial facilities with reliable installations and upgrades.",
    image: "https://images.unsplash.com/photo-1718220216044-006f43e3a9b1"
  },
  {
    id: 2,
    title: "Residential Electrical",
    description: "Expert residential electrical services for your home including installations, upgrades, renovations, and complete electrical solutions for new builds and existing properties.",
    image: "https://images.unsplash.com/photo-1576446470246-499c738d1c8e"
  },
  {
    id: 3,
    title: "Fire Alarm Systems",
    description: "Professional fire alarm installation, maintenance, and inspection services ensuring your property meets all safety codes and regulations for complete peace of mind.",
    image: "https://images.unsplash.com/photo-1653353436174-a8e724190fd3"
  },
  {
    id: 4,
    title: "Electrical Panel Upgrades",
    description: "Greva Electric's electricians expertly provide electrical panel upgrades and replacements, ensuring your property meets modern demands with enhanced safety and efficiency.",
    image: "https://images.pexels.com/photos/12207608/pexels-photo-12207608.jpeg"
  },
  {
    id: 5,
    title: "Electrical Maintenance",
    description: "Comprehensive electrical maintenance services to keep your systems running safely and efficiently. Regular inspections, preventive maintenance, and system optimization.",
    image: "https://images.unsplash.com/photo-1767514536575-82aaf8b0afc4"
  },
  {
    id: 6,
    title: "Troubleshooting & Repair",
    description: "Expert electrical troubleshooting and repair services for power outages, faulty circuits, nonfunctional outlets or switches, and all electrical emergencies.",
    image: "https://images.unsplash.com/photo-1649038780045-235e4b6e40b4"
  },
  {
    id: 7,
    title: "Building & Pylon Signage",
    description: "Professional building and pylon signage repair, maintenance and troubleshooting services. Keep your business signs illuminated and functioning properly to maintain your brand visibility.",
    image: "https://images.unsplash.com/photo-1707960119803-3b2880e847b4"
  },
  {
    id: 8,
    title: "Security Camera & Data Wiring",
    description: "Professional security camera installation and data wiring services. Expert structured cabling, network installation, and surveillance system setup for homes and businesses.",
    image: "https://images.unsplash.com/photo-1669049515462-6ab71c151720"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    text: "Greva Electric did an outstanding job on our commercial building's electrical upgrade. Professional, timely, and their attention to detail was impressive. Highly recommend!",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Thompson",
    text: "Called Greva Electric for an emergency repair. They responded quickly and fixed the issue efficiently. Great service and fair pricing. Will definitely use them again.",
    rating: 5
  },
  {
    id: 3,
    name: "David Chen",
    text: "Had Greva Electric install a complete fire alarm system in our facility. The team was knowledgeable, professional, and completed the work on schedule. Excellent experience!",
    rating: 5
  },
  {
    id: 4,
    name: "Jennifer Williams",
    text: "Greva Electric upgraded our home's electrical panel and added new circuits for our renovation. Clean work, fair price, and very professional. Couldn't be happier!",
    rating: 5
  },
  {
    id: 5,
    name: "Robert Anderson",
    text: "I've used Greva Electric for both residential and commercial projects. They consistently deliver quality work with excellent customer service. Trustworthy and reliable!",
    rating: 5
  }
];

export const locations = [
  {
    id: 1,
    name: "Saskatoon, SK",
    description: "Residents and businesses in Saskatoon, SK, proudly choose Greva Electric for our local expertise, honest service, and exceptional quality work. As a trusted partner in the community, Greva Electric understands your unique needs, ensuring safety and efficiency with every project."
  },
  {
    id: 2,
    name: "Martensville, SK",
    description: "Homeowners and businesses in Martensville, SK, choose Greva Electric for our unwavering reliability and expert electrical services. With a focus on customer satisfaction, we consistently deliver high-quality solutions tailored to each property's unique needs."
  },
  {
    id: 3,
    name: "Warman, SK",
    description: "Homeowners and business owners in Warman, SK, consistently choose Greva Electric as their top electrician due to our friendly service and unmatched expertise. Our commitment to quality and safety ensures each project is handled with precision and care."
  },
  {
    id: 4,
    name: "Surrounding Areas",
    description: "Greva Electric proudly serves Saskatoon and surrounding areas throughout Saskatchewan. From residential homes to commercial facilities, we bring professional electrical services to communities across the region."
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Quality Workmanship",
    description: "Greva Electric's dedication is reflected in our commitment to excellence. We honor all product warranties and provide comprehensive workmanship guarantees on all installations, ensuring peace of mind with reliable solutions."
  },
  {
    id: 2,
    title: "Customer Service",
    description: "Our customer service is second to none. We treat our clients with respect and professionalism. You can expect personal attention and expert service for your home or business. We believe in building trust through attentive service."
  },
  {
    id: 3,
    title: "Free Estimates",
    description: "Transparency is key, so we provide free estimates. This ensures you're fully informed about your project's scope and costs. Choose Greva Electric for a partner who prioritizes your needs and delivers excellence at every turn."
  },
  {
    id: 4,
    title: "Licensed & Insured",
    description: "Greva Electric is fully licensed and insured, meeting all Saskatchewan electrical code requirements. Our team stays current with the latest electrical standards and safety practices to provide you with the highest quality service."
  }
];